import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { supabase } from '../supabaseClient';
import { useAuth } from '../AuthContext';

const LeadCapture = () => {
  const { user } = useAuth();
  const [form, setForm] = useState({ name: '', company: '', phone: '', email: '', material: '' });
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  // If user is logged in, use their email
  const emailValue = user ? user.email : form.email;

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    // Compose message from form fields
    const message = `Company: ${form.company}\nPhone: ${form.phone}\nMaterial: ${form.material}`;
    const { error } = await supabase.from('quote_requests').insert([
      {
        name: form.name,
        email: emailValue,
        message,
        status: 'New',
      }
    ]);
    setLoading(false);
    if (error) {
      setError('Failed to submit request. Please try again.');
    } else {
      setSubmitted(true);
    }
  };

  return (
    <motion.section
      id="lead-capture"
      className="max-w-xl mx-auto py-10 md:py-16 px-2 md:px-4"
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.8, ease: 'easeOut' }}
    >
      <h2 className="text-xl md:text-2xl font-bold text-center text-primary mb-8">Request a Callback</h2>
      {submitted ? (
        <div className="bg-white rounded-xl shadow-soft p-6 text-center text-primary">
          Thank you! We will contact you soon.
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="bg-white rounded-xl shadow-soft p-4 md:p-6 flex flex-col gap-3 md:gap-4">
          <input name="name" required placeholder="Name" className="border border-gray-300 rounded-xl px-3 py-2 md:px-4 md:py-2 focus:outline-accent text-sm md:text-base" value={form.name} onChange={handleChange} />
          <input name="company" required placeholder="Company" className="border border-gray-300 rounded-xl px-3 py-2 md:px-4 md:py-2 focus:outline-accent text-sm md:text-base" value={form.company} onChange={handleChange} />
          <input name="phone" required placeholder="Phone" className="border border-gray-300 rounded-xl px-3 py-2 md:px-4 md:py-2 focus:outline-accent text-sm md:text-base" value={form.phone} onChange={handleChange} />
          <input
            name="email"
            type="email"
            required
            placeholder="Email"
            className="border border-gray-300 rounded-xl px-3 py-2 md:px-4 md:py-2 focus:outline-accent text-sm md:text-base"
            value={emailValue}
            onChange={user ? undefined : handleChange}
            disabled={!!user}
          />
          <input name="material" required placeholder="Material Needed" className="border border-gray-300 rounded-xl px-3 py-2 md:px-4 md:py-2 focus:outline-accent text-sm md:text-base" value={form.material} onChange={handleChange} />
          {error && <div className="text-red-500 text-sm">{error}</div>}
          <button type="submit" className="mt-2 px-4 md:px-6 py-2 bg-accent text-white rounded-xl shadow-soft font-semibold text-sm md:text-base hover:bg-primary transition" disabled={loading}>
            {loading ? 'Submitting...' : 'Request a Callback'}
          </button>
        </form>
      )}
    </motion.section>
  );
};

export default LeadCapture; 